import { useFormContext } from "../../../contexts/form-context";
import useStore from "../../../hooks/use-store";
import { ButtonProps, Button } from "@mui/material";

export default function FormButton({
    disabled,
    children,
    ...props
}: ButtonProps) {
    const form = useFormContext();

    const [isSubmitting] = useStore(form.store, state => [state.isSubmitting]);

    return <Button disabled={disabled || isSubmitting || form.fieldSet.disabled} {...props}>{children}</Button>
}